(function() {

  "use strict";


  angular
    .module("ATMGurus")
    .service("OracleStatusMonitorService", OracleStatusMonitorService);

  angular.$inject = ["$socket", "$rootScope", "$state"];

  function OracleStatusMonitorService($socket, $rootScope, $state)
  {

    var live = true,
      affectedViews = [ /myaccount/, /login/, /checkout/, /products/, /product-details/, /register/ ];

    $socket.on('message', function(working) {
      status(working)
    })

    var service = {
      get: function() {
        return live;
      }
    }

    return service;

    ////////////////////////// PRIVATE

    function status(status) {

      live = status;

      if (status === false) {

        checkIfShouldFireModal();

      } else {

        // All is fine here

      }
    }

    function checkIfShouldFireModal() {


      var displayModal = _.find( affectedViews, function( view ) {
        return view.test( $state.current.name )
      } )

      if (displayModal) {
        fireModal();
      } else {
        console.warn("I know Oracle is down but it doesn't affect this page, so I'm not firing a modal.")
      }

    }

    function fireModal()
    {
      console.warn("I would fire the 'Oracle Down' Modal.");

      $rootScope.$broadcast( "modal.open", {
        title: "SERVER CONNECTION",
        template: "error",
        data: {
        message: "We are experiencing connectivity issues so some of our services are not available at the moment. Please come back in a few minutes!" }
        // message: "Sorry for the inconvenience, we are down for scheduled maintenance." }
      } );
    }

  }

})()


// WEBPACK FOOTER //
// ./src/app/services/OracleStatusMonitor.js